module.exports = __webpack_public_path__ + "static/media/9.c4477d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/9.png
// module id = 1175
// module chunks = 0